// extracted by mini-css-extract-plugin
module.exports = {"title":"ModalTerms_title_1vFi-","titleBox":"ModalTerms_titleBox_11WWQ","modalWrapper":"ModalTerms_modalWrapper_18SA6","modalClose":"ModalTerms_modalClose_1ntdI"};